import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-media-play",
  "use": "icon-media-play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-media-play\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 3H6C5.4 3 5 3.4 5 4V20C5 20.6 5.4 21 6 21H10C10.6 21 11 20.6 11 20V4C11 3.4 10.6 3 10 3ZM9 19H7V5H9V19ZM18 3H14C13.4 3 13 3.4 13 4V20C13 20.6 13.4 21 14 21H18C18.6 21 19 20.6 19 20V4C19 3.4 18.6 3 18 3ZM17 19H15V5H17V19Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol